import { makeStyles } from '@material-ui/core/styles'

import {colors} from '../../theme'

export const useStyles = makeStyles((theme) => ({
  button: {
    alignSelf: 'center',
    backgroundColor: colors.brandOrange,
    color: colors.textGrey,
    fontFamily: 'Mont-Heavy',
    fontWeight: 'bold',
    fontSize: '1em',
    margin: '0 0 1vh',
    textTransform: 'none',
  },
  checked: {},
  closeButton: {
    left: 'auto',
    marginTop: '-4px',
    width: '10%',
  },
  closeIcon: {
    color: colors.brandBlue,
  },
  content: {
    overflowY: 'scroll',
    margin: '2vh 0 1vh',
    padding: '1vh 0 2vh 2vw',
  },
  header: {
    alignItems: 'center',
    borderBottom: `1px solid ${colors.lightGrey}`,
    display: 'flex',
    height: '6vh',
    justifyContent: 'space-between',
    width: '100%',
  },
  modal: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  paper: {
    backgroundColor: colors.white,
    border: `3px solid ${colors.lightBlue}`,
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    height: '70vh',
    padding: theme.spacing(2, 3, 3),
    width: '90%',
  },
  radio: {
    color: colors.brandOrange,
    '&$checked': {
      color: colors.brandOrange,
    },
  },  
  title: {
    color: colors.brandBlue,
    fontFamily: 'Mont-Heavy',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
}))
